module.exports = __webpack_public_path__ + "static/media/miles.e088d7c0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/asset/img/miles.jpg
// module id = 3308
// module chunks = 0